const title = 'Support Spokane'
document.querySelector('#header-title a[href^="/widgets/organizations"]')
.textContent = title
document.title = document.title.replace('Multiple nonprofits', title)
